import React from 'react';
import './Realizations.css';

const Realizations = () => {
  const quotes = [
    "We didn't have a staffing problem — we had a visibility problem.",
    "Once we saw demand clearly, the decisions became obvious.",
    "We stopped reacting and started planning.",
    "We were leaving $3K/week on the table — and had no idea."
  ];

  return (
    <section id="realizations" className="realizations-section">
      <div className="container">
        <h2 className="section-title">What owners usually realize</h2>

        <div className="quotes-grid">
          {quotes.map((quote, index) => (
            <div key={index} className="quote-card">
              <div className="quote-mark">"</div>
              <p className="quote-text">{quote}</p>
            </div>
          ))}
        </div>

        <p className="footer-note">Real insights from salon operators using Jajoga</p>
      </div>
    </section>
  );
};

export default Realizations;
